import img1 from '../images/slider/slide_1.png';
import img2 from '../images/slider/slide_1.png';
import imgbg1 from '../images/slider/bg_slide_1.png';
import imgbg2 from '../images/slider/bg_slide_1.png';

const heroSliderData = [
  {
    title_1: "Hi, I'm Christian",
    title_2: 'a Fullstack &',
    title_3: 'Software Developer',
    description:
      'Find my latest work and Projects utilizing the latest technologies',
    img: img1, // photo of me needs updated
    imgbg: imgbg1, // purple skigiliy
    class: 'left',
  },
  {
    title_1: 'Discover, Find,',
    title_2: 'Extraordinary Talent',
    title_3: 'Excellent Work & Projects ',
    description:
      'Find my latest work and Projects implemented with best practices',
    img: img2,
    imgbg: imgbg2,
    class: 'center',
  },
];

export default heroSliderData;
